import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';
import {ActionButtons} from "_components/ActionButtons/ActionButtons";
import {PageCopy} from "_components/PageCopy/PageCopy";
import {PromocracyLogo} from "_components/PromocracyLogo/PromocracyLogo";
import PageFlow from "_pages/__routes/PageFlow";
import {CustomContent} from '_pages/Variations/CustomContent/CustomContent';
import {PageBackgroundImages} from "_components/PageBackgroundImages/PageBackgroundImages";

import { executeAction } from "__globals/appActions";

import {
    empty,
    logIt
} from '__globals/global-functions';
import {
    clearRaffleTicketStorage
} from '__globals/promocracy-functions';
import * as GC from "__globals/GLOBAL-CONSTANTS";

export const ClearRaffleTickets = props => {

    logIt(GC.PAGE_CLEAR_RAFFLE_TICKETS + " PAGE IS CALLED", null, false);
    const PAGE_DIV_NAME = "clear_raffle_tickets"; // use underscores
    const PAGE_KEY = "clearRaffleTicketws"; // use camel case
    const PAGE_IMAGE_KEY = "clear-raffle-tickets"; // use dashes
    const PAGE_JSON_KEY = "ClearRaffleTickets"; // use init caps

    //const dispatch = useDispatch();

    const promotion = useSelector(state => state.promotion);
    //logIt( "PROMOTION at " + GC.PAGE_CLEAR_RAFFLE_TICKETS, promotion, true );

    // LOCAL VARIABLES
    const [action, setAction] = useState('');
    const [value, setValue] = useState('');
    const [goNext, setGoNext] = useState(false);

    const doAction = (a, v) => {
        if (a.toUpperCase().trim() === GC.ACTION_NAVIGATE) {
            setAction(a);
            setValue(v);
            setGoNext(true);
        } else {
            //dispatch(executeAction(a, v));
        }
    }

    useEffect(() => {
        if ( !empty(promotion) ) {
            clearRaffleTicketStorage();
        }
    }, [promotion] );

    if (goNext) {

        return (<PageFlow page={GC.PAGE_CLEAR_RAFFLE_TICKETS} error={null} action={action} value={value}/>);

    } else {

        return (
            <React.Fragment>
                <TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title}/>
                <div id={PAGE_DIV_NAME + "_page"}>

                    <table>
                        <tbody>
                        <tr>
                            <td className="page-visual">

                                <PageBackgroundImages
                                    promotion={promotion}
                                    pageKey={PAGE_IMAGE_KEY}
                                />

                            </td>
                            <td className="page-content">

                                <div id={PAGE_DIV_NAME + "_content"}>

                                    <PageCopy
                                        promotion={promotion}
                                        configKey={PAGE_KEY}
                                        jsonKey={PAGE_JSON_KEY}
                                    />

<div id="dv_raffle_clear_instructions">RAFFLE TICKETS HAVE BEEN CLEARED</div>

                                    <ActionButtons
                                        promotion={promotion}
                                        configKey={PAGE_KEY}
                                        jsonKey={PAGE_JSON_KEY}
                                        doAction={doAction}
                                    />

                                </div>

                                <PromocracyLogo promotion={promotion}/>

                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <CustomContent/>

                </div>

            </React.Fragment>

        );

    }

}